import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  // baseURL: 'https://www.zwfw.hlj.gov.cn/',
  baseURL: '/',

  timeout: 60000
})
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8"
    // config.headers['Content-Type'] = "application/json"
    // config.headers['Accept'] = "application/json"
    // config.headers['Origin'] = "https://www.hljfinance.com"
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
